class SelectSearchOption {
  constructor(
    public label: string,
    public value: number | string | undefined,
    public css?: string | undefined
  ) {}
}

export default SelectSearchOption;
